import { render, staticRenderFns } from "./imprimirFavsCaso.vue?vue&type=template&id=dd81f4a2&scoped=true&lang=html&"
import script from "./imprimirFavsCaso.vue?vue&type=script&lang=js&"
export * from "./imprimirFavsCaso.vue?vue&type=script&lang=js&"
import style0 from "./imprimirFavsCaso.vue?vue&type=style&index=0&id=dd81f4a2&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd81f4a2",
  null
  
)

export default component.exports